import React from "react";

import { formatNumber, useNavigate, useTranslation } from "utils";

import { FOOTPRINTING_ROUTE } from "consts";

import { NO_FIGURE, StatusCard } from "pages/app/home/status-cards/StatusCard";
import { HomeFootprintingSummaryResult } from "pages/app/home/status-cards/useHomeFootprintingSummary";

type FootprintingCardProps = {
  footprinting: HomeFootprintingSummaryResult;
  hasFields: boolean;
  /** data the card depends on is still loading (fields, reporting year) */
  loading?: boolean;
};

export const FootprintingCard = ({ footprinting, hasFields, loading = false }: FootprintingCardProps) => {
  const { t } = useTranslation("home");
  const navigate = useNavigate();
  const { summary, unavailable } = footprinting;

  return (
    <StatusCard
      dataTestId="home-footprinting-card"
      loading={loading || footprinting.loading}
      label={t("statusCards.footprinting.label")}
      value={unavailable ? NO_FIGURE : `${formatNumber({ number: summary.completionPercent, decimalPlaces: 0 })}%`}
      valueMuted={unavailable}
      unit={unavailable ? t("statusCards.unavailable") : t("statusCards.footprinting.unit")}
      progress={unavailable ? undefined : summary.completionPercent}
      caption={unavailable ? undefined : t("statusCards.footprinting.caption", { count: summary.totalCount, done: summary.doneCount })}
      cta={{ label: t("statusCards.footprinting.cta"), variant: hasFields ? "button" : "circle", onClick: () => navigate(FOOTPRINTING_ROUTE) }}
    />
  );
};
